exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.lightbox-popup[data-v-5f3fda18] {\n  position: fixed;\n  z-index: 1000;\n  background-color: rgba(53, 54, 53, 0.88);\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  padding-top: 53px;\n  -webkit-box-sizing: border-box;\n          box-sizing: border-box;\n  overflow-y: scroll;\n}\n.lightbox-popup[data-v-5f3fda18]::-webkit-scrollbar {\n  display: none;\n}\n.lightbox-popup.mobile[data-v-5f3fda18] {\n  padding-top: 53px;\n}\n.light-box-center[data-v-5f3fda18] {\n  height: 100%;\n  width: 100%;\n}\n.light-box-center .row[data-v-5f3fda18] {\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n  -webkit-box-pack: center;\n      -ms-flex-pack: center;\n          justify-content: center;\n}\n.popup-content[data-v-5f3fda18] {\n  margin-bottom: 53px;\n}\n\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5f3fda18","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./src/components/standard/display/Lightbox.vue
// module id = j5m1
// module chunks = 53